import { Navigate, Route, Routes } from "react-router-dom";
import { Login } from "./pages/Login";
import { AdminLayout } from "./components/admin/AdminLayout";
import { AuthGuard } from "./components/admin/AuthGuard";
import { AdminOnly } from "./components/admin/AdminOnly";
import { Dashboard } from "./pages/admin/Dashboard";
import { Products } from "./pages/admin/Products";
import { ProductEditor } from "./pages/admin/ProductEditor";
import { Categories } from "./pages/admin/Categories";
import { CategoryEditor } from "./pages/admin/CategoryEditor";
import { GrapeVarieties } from "./pages/admin/GrapeVarieties";
import { Tags } from "./pages/admin/Tags";
import { Banners } from "./pages/admin/Banners";
import { BannerEditor } from "./pages/admin/BannerEditor";
import { Collections } from "./pages/admin/Collections";
import { CollectionEditor } from "./pages/admin/CollectionEditor";
import { Inventory } from "./pages/admin/Inventory";
import { Customers } from "./pages/admin/Customers";
import { CustomerDetail } from "./pages/admin/CustomerDetail";
import { Orders, PendingOrders } from "./pages/admin/Orders";
import { OrderDetail } from "./pages/admin/OrderDetail";
import { AbandonedCarts } from "./pages/admin/AbandonedCarts";
import { Promotions } from "./pages/admin/Promotions";
import { NewsletterSubscribers } from "./pages/admin/NewsletterSubscribers";
import { WithdrawalRequests } from "./pages/admin/WithdrawalRequests";
import { Pages } from "./pages/admin/Pages";
import { PageEditor } from "./pages/admin/PageEditor";
import { Blog } from "./pages/admin/Blog";
import { Staff } from "./pages/admin/Staff";
import { BlogPostEditor } from "./pages/admin/BlogPostEditor";
import { CustomerGroups } from "./pages/admin/CustomerGroups";
import { Team } from "./pages/admin/Team";
import { CouriersSettings } from "./pages/admin/CouriersSettings";
import { MoneoSettings } from "./pages/admin/MoneoSettings";
import { CatalogSettings } from "./pages/admin/CatalogSettings";
import { StoreSettings } from "./pages/admin/StoreSettings";
import { Languages } from "./pages/admin/Languages";
import { Visitors } from "./pages/admin/Visitors";
import { SearchAnalytics } from "./pages/admin/SearchAnalytics";
import { Communications } from "./pages/admin/Communications";
import { Integrations } from "./pages/admin/Integrations";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <AuthGuard>
            <AdminLayout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Dashboard />} />

        {/* Wired */}
        <Route path="/products" element={<Products />} />
        <Route path="/products/new" element={<ProductEditor />} />
        <Route path="/products/:id" element={<ProductEditor />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/categories/new" element={<CategoryEditor />} />
        <Route path="/categories/:id" element={<CategoryEditor />} />
        <Route path="/grape-varieties" element={<GrapeVarieties />} />
        <Route path="/tags" element={<Tags />} />
        <Route path="/banners" element={<Banners />} />
        <Route path="/banners/new" element={<BannerEditor />} />
        <Route path="/banners/:id" element={<BannerEditor />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/collections/new" element={<CollectionEditor />} />
        <Route path="/collections/:id" element={<CollectionEditor />} />
        <Route path="/inventory" element={<Inventory />} />

        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/pending" element={<PendingOrders />} />
        <Route path="/orders/abandoned-carts" element={<AbandonedCarts />} />
        <Route path="/orders/:id" element={<OrderDetail />} />

        {/* Reserved — placeholder until each ships */}
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/customer-groups" element={<CustomerGroups />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/newsletter" element={<NewsletterSubscribers />} />
        <Route path="/withdrawals" element={<WithdrawalRequests />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="/pages/new" element={<PageEditor />} />
        <Route path="/pages/:id" element={<PageEditor />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/new" element={<BlogPostEditor />} />
        <Route path="/blog/:id" element={<BlogPostEditor />} />
        <Route path="/translations" element={<Navigate to="/languages" replace />} />
        <Route path="/languages" element={<Languages />} />
        <Route path="/couriers" element={<CouriersSettings />} />
        <Route path="/moneo" element={<MoneoSettings />} />
        <Route path="/catalog-settings" element={<CatalogSettings />} />
        <Route path="/store-settings" element={<StoreSettings />} />
        <Route
          path="/team"
          element={
            <AdminOnly>
              <Team />
            </AdminOnly>
          }
        />
        <Route path="/performance/visitors" element={<Visitors />} />
        <Route path="/performance/search" element={<SearchAnalytics />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/communications" element={<Communications />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
